<template>
  <app-layout>
    <div class="bax-banner-wrap">
      <div class="bax-banner-title-block" >
        <div class="container">
          <div class="bax-banner-title d-md-flex align-items-center">
            <ul class="d-md-flex justify-content-between home-head-banner">
            </ul>
          </div>
        </div>
      </div>
      <div class="bax-banner-content d-flex align-items-end">
        <div class="container">
          <h1 class="d-flex align-items-center"><img src="@/assets/images/login-img.png" alt="Welcome">Manage Recent Orders List</h1>
          <p></p>
        </div>
      </div>
    </div>
    <main>
      <div class="bax-section">
        <div class="container">
          <div class="bax-order-summary-wrap">
            <div class="bax-search-bar d-md-flex align-items-md-center">
              <h2>Your Recent Order List</h2>
              <div class="bax-form-wrapper ml-auto">
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <form novalidate @submit.prevent="searchOrder">
            <div class="bax-search-element bax-dark-gray-1">
              <div  id="favourites-list">
                <ul v-for="(favourite, index ) in favourites" :key="favourite.id">
                  <li class="header"  >
                    {{ favourite.title }}
                    <i class="icon-delete" :data-index="index" @click="deleteFavourite"></i>
                  </li>

                </ul>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import AppLayout from '@/components/layout/AppLayout.vue';
import { scrollPageToTop } from '@/core/helpers';
import DrugService from '@/core/api/drug/drug.service';
import utilsMixin from '@/mixins/utilsMixin';

export default {
  name: 'Home',
  mixins: [utilsMixin],
  components: {
    AppLayout,
  },
  data() {
    return {
      favourites: [],
    };
  },
  computed: {
    ...mapGetters(['authenticatedUser']),
  },
  async created() {
    scrollPageToTop();

    this.loadFavourites();
  },
  methods: {
    async loadFavourites() {
      const favouritesResponse = await DrugService.getAllFavouritesInfo();
      const favouritesArray = [];
      Object.keys(favouritesResponse.data).forEach((key) => {
        const favourite = favouritesResponse.data[key];
        favourite.visible = false;
        favouritesArray.push(favourite);
      });
      this.favourites = favouritesArray;
    },
    deleteFavourite(e) {
      const favChosen = this.favourites[e.target.dataset.index];

      const data = {};
      data.favouriteID = favChosen.id;

      DrugService.deleteFavourite(data);

      this.loadFavourites();
    },
  },
};
</script>

<style scoped>
.home-head-banner {
  height: 32px;
}



</style>
